import React, { useEffect } from 'react';
import Buttons from '../../../../common/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import IconToolTip from '../../../../common/IconToolTip';
import { HandleAccessForButtons } from '../../TeamController';
import { getUserDetails } from '../../../../actions/users'
import { SkeltonCardTwo } from '../../../../common/SkeltonCardTwo';
import { textCss } from '../../../../common/Css';
import { getLinkedProjectOfUsers, projectTeamBlackList, projectTeamWhiteList } from '../../../../actions/project';
import { getCustomerIdOfLoginUser } from '../../../../utils/utils';
import { validateStringValue } from '../../../../utils/common';
import { closeModalAction, openTextModalAction } from '../../../../actions/modal';
import OverflowTip from '../../../../common/OverflowTip';


export default function TeamUserDetails(props) {
  const { onClose, handleRemove, headerComponent } = props;
  const { selectedTeamUserDetails } = useSelector((state) => state.customer)
  const { userDetails } = useSelector((state) => state.user)
  const { linkedUserProjects } = useSelector((state) => state.project)
  const { isUserDetailsLoading } = useSelector((state) => state.loading)
  const dispatch = useDispatch();
  const isToShowDeletButton = HandleAccessForButtons('USERS_TEAM_DELETE')

  const defaultPic = process.env.PUBLIC_URL + './img/default-profile-pic.svg';
  const profile_pic = userDetails?.user?.profilePic;
  const userId = selectedTeamUserDetails && selectedTeamUserDetails?.id

  useEffect(() => {
    if (userId) {
      dispatch(getUserDetails({ userId }))
      dispatch(getLinkedProjectOfUsers({ userId }))
    }
  }, [userId, dispatch]);


  const handleRemoveFromTeam = ({ userDetails, team }) => {
    let data = {
      agentId: userDetails?.userId,
      teamId: team?.id,
      agentName: `${userDetails?.username}`,
      teamName: team?.name,
      customerId: team?.fk_customer_id,
      tabName: 'teams'
    }
    handleRemove(data)
  }

  const teamDetailsUI = () => {
    if (isUserDetailsLoading) return <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6]} height={15} className={'px-8'} />
    else if (!userDetails) return <TeamDetailsNotFound />

    return <div className='h-full overflow-y-auto '>
      <div className='border-t border-scogogray pt-5 h-4/12' >
        <div className=''>

          <img
            src={`${profile_pic ? profile_pic : defaultPic}`}
            className=' h-24 rounded-full mx-auto'
            alt=''
          />
        </div>
        <p className={`text-center mt-m-15 ${textCss?.headerOne}`}>
          {`${userDetails?.user?.full_name}`}
        </p>
        <div className='text-center mt-2 mb-4'>
          <p className={textCss?.headerThree}>{`${userDetails?.user?.email}`}</p>
          <p className={textCss?.detailsValue}>{`${userDetails?.user?.mobile}`}</p>
        </div>
      </div>

      <div className='p-5 border-t-10 h-4/12 overflow-y-auto'>
        <div className='mb-m-15 flex items-center'>
          <div>
            <p className='text-font13 text-scogoprimary font-medium mr-3'>
              Teams
            </p>
          </div>
          <div className=''>
            <p className='bg-scogoorange text-white rounded-full h-7 px-2 leading-7 text-center text-font11 font-medium'>
              {userDetails?.teams?.length}
            </p>
          </div>
        </div>
        {!isUserDetailsLoading ? Array.isArray(userDetails?.teams) && userDetails?.teams?.map(team => (
          <div className='flex'>
            <div>
              <div className='flex items-center mb-5'>

                <div className='w-[28rem] truncate '>
                  <p className={` truncate ${textCss?.inputText}`}>
                    <OverflowTip someLongText={team.name} />
                  </p>
                </div>

              </div>
            </div>
            <div className='ml-auto'>
              <Buttons>
                {isToShowDeletButton ? <IconToolTip title='Remove'>
                  <span onClick={() => handleRemoveFromTeam({ userDetails, team })} className='material-icons  hover:text-scogoorange text-font16 text-scogoclosed'>
                    delete
                  </span>
                </IconToolTip> : <></>}
              </Buttons>
            </div>
          </div>
        )) : <SkeltonCardTwo arr={[1, 2, 3, 4]} height={15} />}

      </div>
      <div className='p-5 border-t-10 h-4/12 overflow-y-auto'>
        <div className='mb-m-15 flex items-center'>
          <div>
            <p className='text-font13 text-scogoprimary font-medium mr-3'>
              Projects
            </p>
          </div>
          <div className=''>
            {linkedUserProjects && <p className='bg-scogoorange text-white rounded-full h-7 px-2 leading-7 text-center text-font11 font-medium'>
              {linkedUserProjects?.length}
            </p>}
          </div>
        </div>
        {!isUserDetailsLoading ? Array.isArray(linkedUserProjects) && linkedUserProjects.map(project => (
          <div className='flex'>
            <div>
              <div className='flex items-center mb-5'>
                <div className=''>
                  {project.isBlacklisted ? <IconToolTip title='User is not part of this project'>
                    <p className={`font-normal text-font11 text-scogoclosed`}>
                      {project.project_name}
                    </p>
                  </IconToolTip> : <p className={textCss?.inputText}>
                    {project.project_name}
                  </p>}
                </div>
              </div>
            </div>
            <TeamProjectAction projectId={project.id} isBlacklisted={project.isBlacklisted} user={userDetails} />
          </div>
        )) : <SkeltonCardTwo arr={[1, 2, 3, 4]} height={15} />}

      </div>
    </div >
  }

  return (
    <div className='sticky'>
      <div className='chatContainerHeader flex items-center'>
        {headerComponent({ headName: 'User Details', onClick: onClose })}
      </div>
      <div className='bg-white overflow-x-hidden groupDetailsHeight'>
        {teamDetailsUI()}
      </div>
    </div>
  );
}

const TeamDetailsNotFound = () => {
  return (
    <div
      className='mx-3 my-2 h-10 items-center flex px-6 rounded-md gap-6'
      style={{ border: '1px solid rgb(178,95,94)', color: 'rgb(145,45,56)' }}
    >
      <p className={textCss?.inputText} style={{ color: 'rgb(145,45,56)' }}>User Details Not Found</p>
    </div>
  );
};


const TeamProjectAction = ({ isBlacklisted, projectId, user }) => {
  const dispatch = useDispatch();
  const { loggedUser } = useSelector((state) => state.auth);
  const customerId = getCustomerIdOfLoginUser(loggedUser);
  let iconClassName = 'material-icons text-scogogray text-font16 text-scogoclosed hover:text-scogoorange'
  let text = 'Remove From Project';
  const userName = `${validateStringValue(user.username)}`;
  let customMessage = `${userName} is removed from project Successfully`;

  if (isBlacklisted) {
    iconClassName = 'material-icons text-scogoToastSuccess text-font16 hover:text-scogoorange';
    text = 'Add To Project'
    customMessage = `${userName} is added from project Successfully`;
  }


  const onClick = () => {
    const formName = 'projectWhiteListorBlackList'
    const payload = {
      projectId,
      userId: user.userId,
      customerId,
      customeMessage: customMessage,
      formName,
      refresh: false,
      callGetLinkedProject: true
    };

    dispatch(
      openTextModalAction({
        heading: isBlacklisted ? 'Add To Project' : 'Remove Project',
        text: `Are you sure you want to ${isBlacklisted ? 'Add' : 'Remove'} to project?`,
        closeOnBackdropClick: false,
        buttons: [
          {
            showLoading: true,
            textOrComponent: 'Yes',
            type: 'blue',
            buttonClass: 'hover:bg-scogobgsky',
            onClick: () => {
              if (isBlacklisted) {
                dispatch(projectTeamWhiteList(payload));
              } else {
                dispatch(projectTeamBlackList(payload));
              }
            },
          },
          {
            textOrComponent: 'No',
            type: 'redOutlined',
            buttonClass: 'hover:bg-scogobgsky',
            onClick: () => {
              dispatch(closeModalAction());
            },
          },
        ],
        formName
      })
    );
  }

  return <div className='ml-auto'>
    <Buttons>
      <IconToolTip title={text}>
        <span onClick={onClick} className={iconClassName}>
          {isBlacklisted ? 'add_task' : 'block'}
        </span>
      </IconToolTip>
    </Buttons>
  </div>
}